import { render, staticRenderFns } from "./_base-flags-history.vue?vue&type=template&id=4b37a033"
import script from "./_base-flags-history.vue?vue&type=script&lang=js"
export * from "./_base-flags-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports